const excludeGraphQLFetch = breadcrumb => {
  if (breadcrumb.category === 'fetch') {
    const url = (breadcrumb && breadcrumb.data && breadcrumb.data.url) || '';

    if (url.includes('/graphql')) {
      return null;
    }
  }

  return breadcrumb;
};

export default excludeGraphQLFetch;
